module.exports = __webpack_public_path__ + "img/mapwithmarkers.71d7116e.jpg";